export default [
  {
    name: 'MOT Testing',
    imgSrc: '/images/sos-55.jpg',
    imgAltText: 'A mechanic inspecting car tyres',
    description:
      'Ensure your vehicle meets the legal standards for roadworthiness with our comprehensive MOT testing service. Our brand-new MOT test lanes are tailor made for Class 4, 5L & 7 MOT Tests. Our certified technicians will thoroughly inspect your car, checking everything from lights and brakes to exhaust emissions and safety features. With our state-of-the-art equipment and expertise, you can trust us to keep your vehicle safe and compliant.'
  },
  {
    name: 'Vehicle Servicing',
    imgSrc: '/images/sos-34.jpg',
    imgAltText: 'A car and a van on vehicles lifts',
    description: 'Keep your car running smoothly and efficiently with our professional vehicle servicing. From basic oil changes to full comprehensive servicing, we offer a range of packages to suit your needs. Our skilled mechanics will perform thorough checks and maintenance tasks, including fluid top-ups, filter replacements, and inspections of vital components. Trust us to maintain your vehicle\'s performance and reliability.'
  },
  {
    name: 'Repairs and Maintenance',
    imgSrc: '/images/sos-61.jpg',
    imgAltText: 'A mechanic taking readings from under a cars bonnet',
    description: 'When your vehicle needs repairs or maintenance, count on us to provide expert service. Whether it\'s brake repairs, suspension adjustments, exhaust system fixes, or any other issue, our team has the knowledge and tools to get your car back on the road safely. We use high-quality parts and follow manufacturer guidelines to ensure lasting repairs and peace of mind.'
  },
  {
    name: 'Tyre Services',
    imgSrc: '/images/sos-33.jpg',
    imgAltText: 'A mechanic servicing a tyre',
    description: 'Keep a grip on the road with our tyre services. We offer tyre inspections, replacements, and alignments to ensure optimal performance and safety. Whether you need new tyres or just a rotation and balance, we\'ll help you choose the right tyres for your vehicle and driving needs.'
  },
  {
    name: 'Diagnostic Checks',
    imgSrc: '/images/sos-23.jpg',
    imgAltText: 'A mechanic performing diagnostic checks on a car',
    description: 'Troubleshooting engine problems? Our advanced diagnostic checks can pinpoint issues quickly and accurately. Using cutting-edge diagnostic tools, we\'ll identify any faults or warning signs in your vehicle\'s systems. With our detailed diagnostic reports, you\'ll have a clear understanding of what needs to be addressed.'
  },
  {
    name: 'Air Conditioning Service',
    imgSrc: '/images/sos-18.jpg',
    imgAltText: 'A mechanic performing air conditioning service',
    description: 'Stay cool and comfortable on the road with our air conditioning service. We\'ll check your system for leaks, recharge refrigerant, clean filters, and ensure your AC is running efficiently. Don\'t let a malfunctioning air conditioner ruin your drive - let us keep you cool and refreshed.'
  },
  {
    name: 'Battery Testing and Replacement',
    imgSrc: '/images/sos-64.jpg',
    imgAltText: 'A car battery being tested',
    description: 'A reliable battery is essential for starting your vehicle and powering its electrical systems. Our battery testing service will assess the health of your battery and recommend replacements if needed. We offer a range of high-quality batteries to suit different vehicle types and budgets.'

  },
  {
    name: 'Brake Inspections and Repairs',
    imgSrc: '/images/sos-27.jpg',
    imgAltText: 'A mechanic performing break repairs',
    description: 'Your safety depends on reliable brakes. Our brake inspections will ensure your braking system is in top condition, from brake pads and discs to hydraulic systems. If repairs are needed, our technicians will use quality parts and precise techniques to restore your brakes\' effectiveness.'
  }
]



// WEBPACK FOOTER //
// ./src/lib/services.js